import React from 'react';
import { Accordion, AccordionProps, palette, Stack, Text } from '@solvhealth/jigsaw-v1';
import dataTestIds from '~/test/test-ids';

const getPriceText = (title: string, selfPay: string) => {
  return (
    <Text muted>
      <span style={{ fontWeight: 'lighter' }}>Self-pay: </span>
      <span
        data-testid={`selfPayPrice-${title}`}
        style={{ fontWeight: 'bold', color: palette.mint.dark }}
      >
        {selfPay}
      </span>
    </Text>
  );
};

const CDPServiceAccordion = (
  props: Omit<AccordionProps, 'accordionVariant' | 'badge' | 'title' | 'subtitle'> & {
    title: string;
    selfPayPrice?: string;
    subtitle?: string;
  }
) => {
  return (
    <div data-testid={`${dataTestIds.cdp.selfPayAccordion}-${props.title}`}>
      <Accordion
        {...props}
        accordionVariant="card"
        subtitle={
          (props.selfPayPrice || props.subtitle) && (
            <Stack marginTop={1} space={1}>
              {props.selfPayPrice && getPriceText(props.title, props.selfPayPrice)}
              {props.subtitle && <div>{props.subtitle}</div>}
            </Stack>
          )
        }
        title={props.title}
      />
    </div>
  );
};

export default CDPServiceAccordion;
